import React, { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import TablePaginationBar, {
  ROWS_PER_PAGE_OPTIONS,
} from "../TablePaginationBar";

export default function Datatable({
  title,
  props,
  currentPage = 1,
  rowsPerPage = 10,
  onPageChange,
  onSearchChange,
  TotalRow,
}) {
  const isServer = typeof onPageChange === "function";
  const data = Array.isArray(props?.data) ? props.data : [];
  const [localPage, setLocalPage] = useState(1);
  const [localRows, setLocalRows] = useState(rowsPerPage || 10);

  useEffect(() => {
    if (!isServer) {
      setLocalPage(1);
    }
  }, [props?.data, isServer]);

  const page = isServer ? currentPage : localPage;
  const rows = isServer ? rowsPerPage : localRows;
  const total = isServer ? TotalRow || 0 : data.length;
  const displayData = isServer
    ? data
    : data.slice((page - 1) * rows, page * rows);

  const handlePageChange = (nextPage) => {
    if (isServer) {
      onPageChange(nextPage, rows);
    } else {
      setLocalPage(nextPage);
    }
  };

  const handleRowsChange = (nextRows) => {
    if (isServer) {
      onPageChange(1, nextRows);
    } else {
      setLocalRows(nextRows);
      setLocalPage(1);
    }
  };

  const options = {
    ...props?.options,
    selectableRows: "none",
    responsive: "standard",
    pagination: false,
    serverSide: isServer,
    filter: false,
    download: false,
    print: false,
    viewColumns: false,
    count: total,
    page: Math.max(0, (page || 1) - 1),
    rowsPerPage: rows,
    rowsPerPageOptions: ROWS_PER_PAGE_OPTIONS,
    setCellProps: () => ({
      style: { padding: "4px 8px", verticalAlign: "middle" },
    }),
    setCellHeaderProps: () => ({
      style: { padding: "6px 8px" },
    }),
    onTableChange: (action, tableState) => {
      if (action === "search" && onSearchChange) {
        onSearchChange(tableState.searchText, currentPage, rowsPerPage);
      }
    },
  };

  return (
    <div className="datatable-with-pager">
      <MUIDataTable
        title={title || ""}
        data={displayData}
        columns={props?.columns || []}
        options={options}
        disableRowSelectionOnClick
      />
      <TablePaginationBar
        page={page}
        rowsPerPage={rows}
        total={total}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsChange}
      />
    </div>
  );
}
